import type { TActivityFe } from "@timeedit/activity-manager-shared-lib/internal/types/Activity/Activity.type";
import {
    isObjectFilterValue,
    type TActivityRow,
    toExtIdLines,
    toObjectFilter,
    toStringArray,
    toTextLines,
} from "./ActivityInfo.utils";

const timingRow = (key: string, label: string, lines: string[]): TActivityRow[] =>
    lines.length > 0
        ? [{ key: `timing:${key}`, label: { text: label }, lines: toTextLines(lines), filters: [] }]
        : [];

export const activity1ToRows = (activity: TActivityFe): TActivityRow[] => {
    // Label by extId since form-based timing has no template to label or format it by.
    const timingRows = (activity.timing ?? []).flatMap((timing, index) =>
        timingRow(`${timing.extId}:${index}`, timing.extId, toStringArray(timing.value))
    );
    const valueRows = (activity.values ?? []).map((value) => {
        const key = `value:${value.extId}`;
        if (isObjectFilterValue(value.value)) {
            return {
                key,
                label: { extId: value.extId, kind: "type" as const },
                lines: [],
                filters: [toObjectFilter(value.extId, value.value)],
            };
        }
        const isObject = value.type === "object";
        return {
            key,
            label: { extId: value.extId, kind: isObject ? ("type" as const) : ("field" as const) },
            lines: isObject
                ? toExtIdLines(toStringArray(value.value), "object")
                : toTextLines(value.value),
            filters: [],
        };
    });
    return [...timingRows, ...valueRows];
};
